export const assetsConstants = {
    COMPANY_NAME: 'Company',
    ADMIN_ROLES: ['Super Admin'],
};
